var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgToLeft(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 6,
    height: 10,
    viewBox: "0 0 6 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.82571 0.111792L0.615335 4.43104C0.541386 4.50691 0.5 4.60866 0.5 4.71461C0.5 4.82055 0.541386 4.9223 0.615335 4.99817L4.82571 9.31904C4.86016 9.35442 4.90134 9.38254 4.94683 9.40174C4.99233 9.42094 5.04121 9.43083 5.09058 9.43083C5.13996 9.43083 5.18884 9.42094 5.23433 9.40174C5.27983 9.38254 5.32101 9.35442 5.35546 9.31904C5.42633 9.24649 5.466 9.14909 5.466 9.04767C5.466 8.94625 5.42633 8.84885 5.35546 8.77629L1.39615 4.71461L5.35546 0.653729C5.42608 0.581212 5.46561 0.483986 5.46561 0.382761C5.46561 0.281535 5.42608 0.184309 5.35546 0.111792C5.32101 0.076413 5.27983 0.0482932 5.23433 0.0290927C5.18884 0.00989219 5.13996 0 5.09058 0C5.04121 0 4.99233 0.00989219 4.94683 0.0290927C4.90134 0.0482932 4.86016 0.076413 4.82571 0.111792Z",
    fill: "#ffffff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgToLeft);
export default __webpack_public_path__ + "static/media/to-left.e90968cc020fb3e03dac6daa473b6d1d.svg";
export { ForwardRef as ReactComponent };